function preencheSelector(id){
    $('#gerapdf').attr('disabled', true);
    var $select = $(id);

    $.ajax({
        url:  '/api/nomesafras/',
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            $select.html('');
            var listaOpcoes = json.map(function(item) {
                return item.nome;
            });

            for (var i = 0; i < listaOpcoes.length; i++) {
                $select.append('<option id="' + listaOpcoes[i] + '">' + listaOpcoes[i] + '</option>');
            }
        }
    });
}



preencheSelector('#selecsafra');
preencheSelector('#selecsafra2');
preencheSelector('#selecsafra3');
preencheSelector('#selecsafra4');
